import React, { useCallback, useEffect } from 'react';
import CapHeading from '@capillarytech/cap-ui-library/CapHeading';
import CapButton from '@capillarytech/cap-ui-library/CapButton';
import { CAP_SECONDARY } from '@capillarytech/cap-ui-library/styled/variables';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import messages from './messages';
import repairImage from '../../../assets/repair.png';
import { publicPath, prefixPath } from '../../../config/path';
import { gtmPush } from '../../../utils/gtmTrackers';

const SomethingWentWrongContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: center;
  align-items: center;
`;
const SomethingWentWrong = () => {
  const onClickReload = useCallback(() => {
    if (window.location.pathname.includes('somethingwentwrong')) {
      window.location = `${window.location.origin}${publicPath}/list`;
    } else {
      window.location.reload();
    }
  }, []);

  // Escape hatch: when a remote is unavailable in the cluster, "Try refreshing again"
  // reloads the same dead URL and never recovers. Send the user to the host home
  // (full page load of domain + /home/ui) so the shell reloads clean.
  const onClickHome = useCallback(() => {
    window.location.href = `${window.location.origin}${publicPath}`;
  }, []);

  useEffect(() => {
    gtmPush('errorScreen');
  }, []);

  // "Go to home" would be a no-op (or a reload loop if home itself errored) when we
  // are already within the host home app — hide it there.
  const { pathname } = window.location;
  const isOnHome = pathname === publicPath || pathname.startsWith(prefixPath);

  return (
    <SomethingWentWrongContainer>
      <img src={repairImage} alt="" />
      <CapHeading type="h3" className="margin-t-34">
        <FormattedMessage {...messages.somethingWentWrongTitle} />
      </CapHeading>
      <CapHeading type="h5" className="margin-t-8">
        <FormattedMessage {...messages.somethingWentWrongDesc} />
      </CapHeading>
      <CapButton
        type="link"
        className="margin-t-16 try-refreshing-btn"
        style={{ color: CAP_SECONDARY.base }}
        onClick={onClickReload}
      >
        <FormattedMessage {...messages.tryRefreshing} />
      </CapButton>
      {!isOnHome && (
        <CapButton
          type="link"
          className="margin-t-8 go-to-home-btn"
          style={{ color: CAP_SECONDARY.base }}
          onClick={onClickHome}
        >
          <FormattedMessage {...messages.goToHome} />
        </CapButton>
      )}
    </SomethingWentWrongContainer>
  );
};

export default SomethingWentWrong;
